import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'components/Button';
import { getStudentRegisterUrl } from 'utils/helper';

// <editor-fold desc="StudentIntro type definitions ...">

export type StudentIntroProps = {
  title?: string;
  description?: string;
  sectorNameSlug: string;
};
// </editor-fold>

// <editor-fold desc="StudentIntro component definition ...">
const StudentIntro = ({
  title = '',
  description = '',
  sectorNameSlug,
}: StudentIntroProps): JSX.Element => {
  const { t } = useTranslation();

  const defaultIntroText = t(
    'Tiitus on oppilaitosten yhteinen keskitetty kanava opiskelijoiden työ- ja harjoittelupaikkojen ilmoittamiseen. Tiituksesta löytyvät siis kaikki opiskelijoiden työ- ja harkkapaikat.',
  );

  return (
    <Container>
      <Row>
        <Col xs={12} className="p-4">
          <h2 className="text-primary">{title}</h2>
          <p>{description}</p>
          <Button href={getStudentRegisterUrl(sectorNameSlug)} target="_blank">
            {t('Luo opiskelijaprofiili')}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
// </editor-fold>

export default StudentIntro;
